// extracted by css-extract-rspack-plugin
export default {"addedImage":"BCfhFY6kWdU37qDR","removedImage":"Z_LNJFdZJQMM06YR"};